import { browserTracingIntegration, getCurrentScope, init } from '@sentry/remix'

export const ClientSentry = {
  init,
  browserTracingIntegration,
  getCurrentScope: () => null as any,
}
